import miniEffectManager from '../effect/mini';
import miniManager from '../../page/mini';

let effect;
let mini;

/* ---------------------------------------

    -- スクロール位置で発火するやつはここ

--------------------------------------- */
export default class miniAnimation{
    constructor(param){

        effect = new miniEffectManager();
        mini = new miniManager();
        mini.init();

        this.$target = document.querySelectorAll('.js__tsc');
        this.scPoint = [];
        this.scNum = this.$target.length;

        this.useText = document.querySelectorAll(".js__use-text");
        this.object = document.querySelectorAll(".js__object-fade");

        if(this.useText) effect.useText(this.useText,"set");
        if(this.object) effect.objectFade(this.object,"set");
        effect.compact("set");

        this.param = param;
        this.resize();

        this.status = {
            comp : false /* 全部処理が終わったか */
        }

    }
    check(inc,winH){
        if(this.status.comp) return;

        let _minusPoint = (Useragnt.pc)?winH/1.5:winH;

        if(this.$target){
            for(var i=0; this.scNum>i; i++){

                if(this.scPoint[i] - _minusPoint < inc  ) {
                    let $scp = this.$target[i];
                    if(!$scp.classList.contains("is-show")){
                        $scp.classList.add("is-show");

                        this.useText = $scp.querySelectorAll(".js__use-text");
                        this.object = $scp.querySelectorAll(".js__object-fade");

                        if(this.useText.length > 0) effect.useText(this.useText,"show",this.param);
                        if(this.object.length > 0) effect.objectFade(this.object,"show");

                        if($scp.id === 'concept-block02'){
                            effect.compact("show");
                        }else if($scp.id === 'concept-block03'){
                            mini.scroll();
                        }

                        if(i==this.$target.length-1) this.status.comp = true;

                    }

                }

            }

        }

    }

    resize (_h) {

        if(this.$target){

            this.scPoint = [];
            for( var i=0; i<this.scNum; i++) {

                let $scp = this.$target[i];

                this.scPoint[i] = $scp.getBoundingClientRect().top;
            }
        }

    }
}